import type { AdNode } from "../../../core/AdNode";

/**
 * Fetches the config for the ad node to return all possible slot sizes
 *
 * @param node the node to fetch data for from the AdNode Manager
 * @returns an array of "x" joined size strings, for all the sizes configured for this slot.
 *
 * Example:
 * ["300x250","300x600","300x1050"]
 */
export function getAllConfiguredSlotSizes(node: AdNode): string[] {
  const nodeSizes = node.getSlotConfig().sizes as googletag.MultiSize;

  return nodeSizes.map((size) => {
    return sizeToString(size);
  });
}

/**
 * An ad size can be represented as a tuple of [width, height], or a string
 * name representing a named size e.g. "fluid". For data reporting purposes,
 * we want to convert the tuple format to a string of width x height, such as "300x600"
 * @param size - a single ad size, in one of various formats
 * @returns
 * "" empty string if null input provided
 * "x" joined string if array provided e.g. "300x600"
 * directly returns the provided string if a string is provided e.g. "fluid" (this would typically be a googletag.NamedSize)
 */
export function sizeToString(
  size: googletag.SingleSize | string | number[] | null,
): string {
  if (!size) {
    return "";
  }
  return Array.isArray(size) ? size.join("x") : size;
}
